module.exports = __webpack_public_path__ + "static/media/FormatoSimplificado_2318723.6e40083b.pdf";


//////////////////
// WEBPACK FOOTER
// ./src/media/img_on_amazon/FormatoSimplificado_2318723.pdf
// module id = 837
// module chunks = 0